import { ITreeviewNhomLopFocusedValue } from "../../../components-data/treeview-nhom-lop/TreeviewNhomLop";
import { IKeHoachNhomLopSelectRequest } from "../../../model/request/ke-hoach/IKeHoachNhomLopSelectRequest";
import { IKeHoachNhomLopSysRequest } from "../../../model/request/ke-hoach/IKeHoachNhomLopSysRequest";
import { IKeHoachNhomLopTachLopRequest } from "../../../model/request/ke-hoach/IKeHoachNhomLopTachLopRequest";
import { IKeHoachNhomLop } from "../../../model/respone/ke-hoach/IKeHoachNhomLop";
import { IKehoachNhomLopViewModel } from "../../../model/respone/ke-hoach/IKehoachNhomLopViewModel";
import { IKeHoachNhomLopFilter } from "../../reducer-model/ke-hoach/IKeHoachNhomLopReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eKeHoachNhomLopActionsObj = {
    LOAD_START: {} as IKeHoachNhomLopSelectRequest,
    LOAD_SUCCESS: {} as IKehoachNhomLopViewModel[],
    LOAD_ERROR: "",

    SYS_FROM_KE_HOACH_MON_START: {} as IKeHoachNhomLopSysRequest,
    SYS_FROM_KE_HOACH_MON_SUCCESS: undefined,
    SYS_FROM_KE_HOACH_MON_ERROR: "",

    CHANGE_FOCUSED_DATA: {} as ITreeviewNhomLopFocusedValue,

    UPDATE_START: {} as IKeHoachNhomLop,
    UPDATE_SUCCESS: {} as IKeHoachNhomLop,
    UPDATE_ERROR: "",

    CHANGE_FILTER: {} as IKeHoachNhomLopFilter,

    TACH_LOPS_START: {} as IKeHoachNhomLopTachLopRequest,
    TACH_LOPS_SUCCESS: undefined,
    TACH_LOPS_ERROR: "",

    DELETE_START: {} as number[],
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
}

export const eKeHoachNhomLopActionIds = generateActionTypeIds(eKeHoachNhomLopActionsObj, "KE_HOACH_NHOM_LOP");
export type IKeHoachNhomLopActionTypes = IGenericActionType<typeof eKeHoachNhomLopActionsObj, "KE_HOACH_NHOM_LOP">;